import { Text } from "../../Type";

const TextCell = ({ value }: { value: string }) => {
  if (!value) return <Text>-</Text>;
  return <Text>{value}</Text>;
};

export default TextCell;
